import React, { useState } from "react";
import { Row, Col, Button, Form, Input, Checkbox } from "antd";
import { authenticatedRoutes } from "../../routes/constant";
import { Link } from "react-router-dom";
import AuthService from "../../services/auth.service";
import _AuthUtil from "../../util/auth.service"
import notificationService from "../../util/notification.service";
import mailPlaceholder from "../../assets/images/mail.svg";
import Logo from "../../assets/images/logo.png";
import { STORAGE_CONST } from "../../constants/constant";
import LocalStorageService from "../../util/local-storage.service";
import "./login.less";
import { useHistory } from "react-router-dom";
import useQueryParams from "../../hooks/useQuery";
import utilService from "../../util/utils.service";
import apiv2Service from "../../util/apiv2.service";
const FormItem = Form.Item;

const Login = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const { queryParams } = useQueryParams({ redirectTo: "" });

    const validatePassword = (_, value) => {
        if (/\s/.test(value)) {
            return Promise.reject(
                new Error("Password should not contain spaces")
            );
        }
        return Promise.resolve();
    };

    const onFinish = async (values) => {
        setLoading(true);
        const pId = localStorage.getItem("os-user");
        const payload = {
            rememberMe: values?.remember ?? false,
            ...values,
            ...(pId && { playerId: pId }),
        };

        const { ok, data } = await AuthService.login(payload);
        if (ok) {
            LocalStorageService.set(
                STORAGE_CONST.USER_INFO,
                JSON.stringify(data)
            );
            let query = queryParams
            const role = _AuthUtil.getRole()
            apiv2Service.setBaseUrl(role)
            history.replace(query?.redirectTo ?? authenticatedRoutes.DASHBOARD);
        } else {
            notificationService.error(data?.message);
        }
        setLoading(false);
    };

    return (
        <Row
            className="auth-background register-wrap reset-pass-main gx-pt-2"
            justify={"center"}
            align={"middle"}
        >
            <Col lg={12} xl={12} xxl={12} md={20}>
                <Row gutter={[0, 25]} type="flex">
                    <Col span={24} align="middle" justify="center">
                        <div className="gx-app-logo">
                            <img src={Logo} />
                        </div>
                        <div className="gx-app-logo">
                            <p>Welcome Back</p>
                            <h2>Sign in to continue</h2>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-login-content">
                                <Form
                                    // initialValues={{ remember: true }}
                                    name="basic"
                                    onFinish={onFinish}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Email is required.",
                                            },
                                            {
                                                type: "email",
                                                message:
                                                    "The input is not valid E-mail!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            style={{ color: "black" }}
                                            placeholder="Email"
                                            suffix={
                                                <img src={mailPlaceholder} />
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your password!",
                                            },
                                            { validator: validatePassword },
                                        ]}
                                    >
                                        <Input.Password
                                            className="inpt"
                                            placeholder="Password"
                                        />
                                    </Form.Item>
                                    <div className="gx-d-flex gx-justify-content-between">
                                        <Form.Item
                                            className="login-formItem-container"
                                            name="rememberMe"
                                            valuePropName="checked"
                                        >
                                            <Checkbox>Remember Me</Checkbox>
                                        </Form.Item>
                                        <Link
                                            style={{
                                                color: `#909AA6`,
                                            }}
                                            to="/forget-password"
                                        >
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            className="gx-mt-4 butn"
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            Login
                                        </Button>
                                    </FormItem>
                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                Don't have an account ?{" "}
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/register"
                                                >
                                                    Register Now
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/privacy-policy"
                                                >
                                                    Privacy Policy
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/contact-us"
                                                >
                                                    Contact Us
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Login;
